/** A small minor-key signature, adapted in rhythm and resolution for each occasion. */
export function motifNotes(rootHz: number, variant: 'deploy' | 'combat' | 'success'): readonly {
  offset: number; frequency: number; duration: number; gain: number;
}[] {
  const offsets = variant === 'deploy' ? [0, 0.1, 0.2, 0.36]
    : variant === 'success' ? [0, 0.13, 0.26, 0.43] : [0, 0.15, 0.3, 0.6];
  const intervals = variant === 'success' ? [0, 3, 7, 12] : [0, 3, 7, 3];
  return offsets.map((offset, i) => ({
    offset,
    frequency: rootHz * 2 ** (intervals[i] / 12),
    duration: i === 3 ? 0.24 : 0.14,
    gain: i === 3 ? 0.07 : 0.06,
  }));
}
